"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var get = require("lodash/get");
var serverEvents_1 = require("../utils/serverEvents");
var KEYWORD_DEV_TO_PROVIDE = 'devToProvide';
var DEFAULT_CONFIG = {
    version: '3.0.0',
    eventApi: {
        url: 'https://event-api.urbanclap.com/newevent',
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
            'x-api-token': 'oa4hulm06qctaaligr1cq3ohhmo33c5j',
        },
        requestMethod: 'POST',
    },
    dupeDiff: 300,
    attributionValidDays: 28,
};
var ServerEventManager = /** @class */ (function () {
    function ServerEventManager(event) {
        this.event = event;
        this.devOverrides = {};
        this.store = window.acmw ? window.acmw.store : {};
        this.config = window.acmw ? window.acmw.config : DEFAULT_CONFIG;
    }
    ServerEventManager.init = function (config) {
        var mergedConfig = __assign({}, DEFAULT_CONFIG, config);
        window.acmw = __assign({}, window.acmw, { config: mergedConfig });
        if (!(window.acmw && window.acmw.store) && !config.disabled) {
            serverEvents_1.serverSync(function (data, failedAttempts) {
                var serverTsDiff = Date.now() - data.server_time;
                var session = new serverEvents_1.Session(serverEvents_1.getTime(serverTsDiff), data.uuid);
                window.acmw = __assign({}, window.acmw, { store: {
                        serverSid: data.uuid,
                        failedAttempts: failedAttempts,
                        serverTsDiff: serverTsDiff,
                        session: session
                    }, defaultData: {
                        uuid: serverEvents_1.cookie.get('_uca_uuid') ||
                            (serverEvents_1.cookie.set('_uca_new_user', 'true', 1) && serverEvents_1.cookie.set('_uca_uuid', serverEvents_1.uuid())),
                        sessionId: session.getId(),
                        version: mergedConfig.version,
                        url: window.location.href || null,
                        referrer: document.referrer || null,
                        referrerDomain: document.referrer ? serverEvents_1.getReferrerDomain() : null,
                        userAgent: window.navigator ? window.navigator.userAgent : null,
                    } });
                serverEvents_1.fireSession(session, serverTsDiff, mergedConfig, window.acmw.defaultData);
                serverEvents_1.utmAttribution(mergedConfig.attributionValidDays);
                if (window.acmw.queue && window.acmw.queue.length) {
                    window.acmw.queue.map(function (queuedEvent) {
                        new ServerEventManager(queuedEvent.event).fire(queuedEvent.trigger, {}, queuedEvent.callback);
                    });
                    window.acmw.queue = [];
                }
            }, 0);
        }
    };
    ServerEventManager.prototype.fire = function (trigger, devOverrides, callback) {
        this.devOverrides = devOverrides;
        var serverEvents = sessionStorage.getItem("serverEvents");
        serverEvents = serverEvents ? serverEvents.split(",") : [];
        serverEvents.push(trigger);
        sessionStorage.setItem("serverEvents", serverEvents.toString());
        try {
            var mergedEvent = this.merge();
            if (mergedEvent) {
                this.send(trigger, mergedEvent, callback);
            }
            return mergedEvent;
        }
        catch (err) {
            // tslint:disable-next-line:no-console
            console.error(err.message, trigger);
            return;
        }
    };
    ServerEventManager.prototype.getValue = function (path) {
        var originalValue = get(this.event, path);
        if (originalValue === KEYWORD_DEV_TO_PROVIDE) {
            var overrideValue = get(this.devOverrides, path);
            if (overrideValue === null || overrideValue === undefined) {
                console.error("One of the devToProvide fields is missing - " + path);
            }
            return overrideValue;
        }
        return originalValue;
    };
    ServerEventManager.prototype.getData = function (path) {
        var _a;
        var eventValue = get(this.event, path);
        if (eventValue === KEYWORD_DEV_TO_PROVIDE) {
            var overrideValue = get(this.devOverrides, path);
            if (overrideValue === null || overrideValue === undefined) {
                console.error("One of the devToProvide fields is missing - " + path);
            }
            return overrideValue;
        }
        else if (typeof eventValue === "object")
            for (var _i = 0, _b = Object.entries(eventValue); _i < _b.length; _i++) {
                var _c = _b[_i], key = _c[0], value = _c[1];
                var overrideKey;
                var overrideValue = void 0;
                if (!!value && value !== KEYWORD_DEV_TO_PROVIDE) {
                    overrideKey = value;
                }
                else {
                    overrideValue = get(this.devOverrides, path + "." + key);
                    if (overrideValue === null || overrideValue === undefined) {
                        console.error("One of the devToProvide fields is missing - " + overrideKey);
                    }
                    else {
                        eventValue = __assign({}, eventValue, (_a = {}, _a[key] = overrideValue, _a));
                    }
                }
            }
        return eventValue;
    };
    ServerEventManager.prototype.prepareEvent = function () {
        return {
            event_timestamp: serverEvents_1.getTime(this.store.serverTsDiff).toString(),
            client_timestamp: ((new Date()).getTime()).toString(),
            schema_type: 'event',
            session: {
                session_id: this.store.session.getId(),
                start_timestamp: this.store.session.getStartTs().toString(),
            },
            user: {
                user_type: this.config.userType || '',
                user_id: serverEvents_1.cookie.get('_uc_user_id') || '',
            },
            context: {
                customer_id: serverEvents_1.cookie.get('_uc_user_id') || '',
                category_key: serverEvents_1.cookie.get('categoryKey') || '',
                city_key: serverEvents_1.cookie.get('currentCity') || '',
            },
        };
    };
    ServerEventManager.prototype.send = function (trigger, eventData, callback) {
        if (this.config.disabled) {
            // tslint:disable-next-line:no-console
            console.log(trigger, eventData);
        }
        else {
            if (this.store && this.store.session) {
                eventData = __assign({}, this.prepareEvent(), eventData);
                serverEvents_1.fireXhr(this.config.eventApi.url, [eventData], this.config.eventApi.requestMethod, this.config.eventApi.headers, callback);
            }
            else {
                var eventToQueue = {
                    event: eventData,
                    trigger: trigger,
                    callback: callback
                };
                window.acmw && window.acmw.queue ? window.acmw.queue.push(eventToQueue) : window.acmw = __assign({}, window.acmw, { queue: [eventToQueue] });
            }
        }
    };
    // private init = () => {
    //   if(this.uc.analytics) {
    //     this.log('Urbanclap Analytics already loaded.');
    //     return false;
    //   }
    //   typeof this.uca.config === "object" && this.extend(this.config, this.uca.config);
    //   this.store.uuid = this.cookie.get('_uca_uuid') ||
    //    (this.cookie.set('_uca_new_user', 'true', 1) && this.cookie.set('_uca_uuid', this.uuid()));
    //   this.session.start(this.store.serverSid, true);
    //   this.defaultData = {
    //     uuid: this.store.uuid,
    //     sessionId: this.store.session.id,
    //     version: this.version,
    //     url: window.location.href || null,
    //     referrer: document.referrer || null,
    //     referrerDomain: document.referrer ? (function() {
    //         let a = document.createElement('a');
    //         a.href = document.referrer;
    //         return a.hostname.replace(/^www\./i, "");
    //       })() : null,
    //     userAgent: window.navigator ? window.navigator.userAgent : ""
    //   };
    //   typeof this.uca.defaultData === "object" && this.extend(this.defaultData, this.uca.defaultData);
    //   this.store.queuedEvents = this.uca.queue;
    //   this.utmAttribution();
    //   this.fireSession();
    //   return {
    //     track: this.track.bind(this),
    //     startSession: this.session.start.bind(this),
    //     endSession: this.session.end.bind(this)
    //   };
    // }
    // private isDuplicate(eventData: EventDataInterface) {
    //   let prevEvent = this.store.previous.event;
    //   if(
    //     prevEvent &&
    //     prevEvent.event.name === eventData.event.name &&
    //     prevEvent.event.action === eventData.event.action &&
    //     prevEvent.event.page === eventData.event.page
    //   ) {
    //     if((new Date()).getTime() - this.store.previous.ts <= this.config.dupeDiff) {
    //       this.config.log && this.log('Duplicate event ignored - ', eventData.event.name, eventData);
    //       return true;
    //     }
    //   }
    //   return false;
    // }
    // private track(eventData: EventDataInterface) {
    //   if(this.isDuplicate(eventData)) {
    //     this.store.previous = {
    //       event: eventData,
    //       ts: (new Date()).getTime()
    //     };
    //     return false;
    //   }
    //   this.store.previous = {
    //     event: eventData,
    //     ts: (new Date()).getTime()
    //   };
    //   this.config.log && eventData.event && this.log(eventData.event.name, eventData);
    //   if(!eventData || typeof eventData !== "object") {
    //     this.log('Invalid event.');
    //     return false;
    //   }
    //   if(this.config.disabled) {
    //     return false;
    //   } else {
    //     this.send(eventData);
    //     return true;
    //   }
    // }
    ServerEventManager.prototype.merge = function () {
        return {
            schema_type: this.getValue('schema_type'),
            event: {
                type: this.getValue('event.type'),
                name: this.getValue('event.name'),
                page: this.getValue('event.page'),
                section: this.getValue('event.section'),
                action: this.getValue('event.action'),
                position: this.getData('event.position'),
                value: this.getData('event.value'),
                trigger_source: this.getValue('event.trigger_source'),
            },
            context: {
                customer_id: this.getValue('context.customer_id'),
                provider_id: this.getValue('context.provider_id'),
                request_id: this.getValue('context.request_id'),
                lead_id: this.getValue('context.lead_id'),
                category_key: this.getValue('context.category_key'),
                locality_key: this.getValue('context.locality_key'),
                city_key: this.getValue('context.city_key'),
            },
            meta_qa_flow: {
                from_question_title: this.getValue('meta_qa_flow.from_question_title'),
                to_question_title: this.getValue('meta_qa_flow.to_question_title'),
                from_question_type: this.getValue('meta_qa_flow.from_question_type'),
                to_question_type: this.getValue('meta_qa_flow.to_question_type'),
                from_question_number: this.getValue('meta_qa_flow.from_question_number'),
                to_question_number: this.getValue('meta_qa_flow.to_question_number'),
                qa_type: this.getValue('meta_qa_flow.qa_type'),
                question_tag: this.getValue('meta_qa_flow.question_tag'),
                answer_tag: this.getValue('meta_qa_flow.answer_tag'),
                category_questions_id: this.getValue('meta_qa_flow.category_questions_id'),
            },
        };
    };
    return ServerEventManager;
}());
exports.ServerEventManager = ServerEventManager;
//# sourceMappingURL=Server.js.map